import {
  useId,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useClickAway } from "react-use";
import IconInfo from "app/icons/IconInfo";

export interface GameMenuHandle {
  close: () => void;
}

interface GameMenuProps {
  children: React.ReactNode;
}

const GameMenu = forwardRef<GameMenuHandle, GameMenuProps>(
  (props, ref) => {
    const topDivRef = useRef<HTMLDivElement>(null);
    const id = useId();
    const [isOpen, setIsOpen] = useState(false);
    const menuId = `menu-${id}`;
    const buttonId = `menubutton-${id}`;

    useClickAway(topDivRef, () => {
      setIsOpen(false);
    });

    useImperativeHandle(ref, () => ({
      close: () => setIsOpen(false),
    }));

    return (
      <div ref={topDivRef} className="relative inline-flex h-fit w-fit">
        <button
          className="cursor-pointer"
          id={buttonId}
          aria-haspopup="true"
          aria-expanded={isOpen ? "true" : "false"}
          aria-controls={menuId}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <IconInfo />
        </button>

        {isOpen && (
          <div
            className="absolute end-0 start-auto top-full z-10 my-1 grid w-47.5 grid-cols-1 items-center justify-center border border-black bg-green-mid text-black text-center text-sm font-medium uppercase shadow-modal *:h-10"
            id={menuId}
            role="menu"
            tabIndex={-1}
            aria-labelledby={buttonId}
          >
            {props.children}
          </div>
        )}
      </div>
    );
  },
);

GameMenu.displayName = "GameMenu";

export default GameMenu;
